export default __webpack_public_path__ + "static/media/fruit-1440w.6b1515b2.avif";